var exports = {
  "kJ": "GiftEmbed.module__iconCircle___eFF4RE",
  "SP": "GiftEmbed.module__iconCircleActive___eFF4RE",
  "PP": "GiftEmbed.module__iconCircleInactive___eFF4RE",
  "_O": "GiftEmbed.module__iconCircleDisabled___eFF4RE",
  "Kk": "GiftEmbed.module__icon___eFF4RE",
  "m5": "GiftEmbed.module__iconError___eFF4RE",
  "DD": "GiftEmbed.module__title___eFF4RE",
  "jn": "GiftEmbed.module__titlePrimary___eFF4RE",
  "xP": "GiftEmbed.module__titleTertiary___eFF4RE",
  "S3": "GiftEmbed.module__titleDanger___eFF4RE",
  "xF": "GiftEmbed.module__subRow___eFF4RE",
  "Cz": "GiftEmbed.module__helpRow___eFF4RE",
  "mj": "GiftEmbed.module__skeletonCircle___eFF4RE",
  "Iz": "GiftEmbed.module__skeletonTitle___eFF4RE",
  "hI": "GiftEmbed.module__skeletonHelp___eFF4RE",
  "G3": "GiftEmbed.module__skeletonButton___eFF4RE",
};

module.exports = exports;
